import React, { useCallback } from 'react';

import { compare, Rule } from './helpers';
import {
  ConditionalLogicActionTypeEnum,
  ConditionalLogicFragmentFragment,
  ConditionalLogicLogicTypeEnum,
} from '../../../../__generated__/graphql';
import { useGetFieldValues } from '../../state/hooks';

interface ConditionalWrapperProps {
  children: React.ReactNode;
  conditionalLogic: ConditionalLogicFragmentFragment | null | undefined;
}

const ConditionalWrapper = ({
  children,
  conditionalLogic,
}: ConditionalWrapperProps) => {
  const actionType = conditionalLogic?.actionType ?? null;
  const logicType = conditionalLogic?.logicType ?? null;
  const rules = (conditionalLogic?.rules?.filter(Boolean) ?? []) as Rule[];

  const ruleIds = rules.map(r => r.fieldId)
    .filter((r): r is number => !!r);

  const ruleValues = useGetFieldValues(ruleIds);

  const matcher = useCallback((rule: Rule) => {
    const ruleValue = ruleValues[rule.fieldId];

    if (ruleValue !== undefined && ruleValue !== null) {
      return compare(ruleValue, rule.operator, rule.value);
    }

    return false;
  }, [ruleValues]);

  if (!conditionalLogic) {
    return children;
  }

  let metCondition = false;

  if (logicType === ConditionalLogicLogicTypeEnum.All) {
    metCondition = rules.every(matcher);
  }

  if (logicType === ConditionalLogicLogicTypeEnum.Any) {
    metCondition = rules.some(matcher);
  }

  if (actionType === ConditionalLogicActionTypeEnum.Hide && metCondition) {
    return null;
  }

  if (actionType === ConditionalLogicActionTypeEnum.Show && !metCondition) {
    return null;
  }

  return children;
};

export default ConditionalWrapper;
